import Constructor from '../constructor'
import Map from './module/map'

class Register extends Constructor(Map) {}

export default Register